import styled from 'styled-components'
import { largeLayout } from '@chegg-wt/core/theme/theme'

export const SpacedFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${(props) => largeLayout(props.theme)}) {
    padding: 0 16px;
  }
`

export const Wrapper = styled.div`
  max-width: 960px;
  padding: ${({ theme }) => theme.spacing.md3} ${({ theme }) => theme.spacing.md2};
`
export const Title = styled.h1`
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor15};
  font-size: 34px;
  font-weight: ${({ theme }) => theme.font.weight.medium};
`
export const Copy = styled.p`
  font-family: inherit;
  margin-bottom: 50px;
  font-size: ${({ theme }) => theme.font.text.size.lg};
  line-height: ${({ theme }) => theme.spacing.lg};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor15};
`
